module.exports = __webpack_public_path__ + "static/media/DINNextLTW23-Bold.d4b0c799.woff";